<template>
  <div class="zuiminjxwd">
    <div class="bt">精选刑法问答</div>
    <el-carousel trigger="click" :interval="5000" 
        arrow="never" height="880px" class="wtswi">
      <el-carousel-item v-for="item in 2" :key="item">
        <div class="hdlist">
          <div class="hditem" v-for="(item, index) in 4" :key="index">
            <div class="cont_w flex_start ellipsis">
              <img src="~assets/question/w.png" />

              {{
                `好，我想离婚了，我想起诉离婚，我也不懂，`
                  | toEllipsisFilter(40)
              }}
            </div>
            <div class="cont_d flex_start">
              <img src="~assets/question/d.png" />
              {{
                `无法协议离婚的，应向法院起诉离婚。法院判决离婚的标准是夫妻感情是否确已破裂，如达到这一标准的，一般情况下会判离婚。婚姻法第三十`
                  | toEllipsisFilter(50)
              }}
            </div>
            <div class="cont_bom flex_start">
              <div>
                <img src="~assets/base/small_rentou.png" />
                <img src="~assets/base/small_rentou.png" />
                <img src="~assets/base/small_rentou.png" />
              </div>
              <div class="FontSize14"><span>3</span>位律师回复</div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.zuiminjxwd {
  padding: 24px 22px;
  .bt {
    font-size: 24px;
    color: #333333;
    line-height: 24px;
  }
  .wtswi {
    .hdlist {
      padding: 4px 0;
      .hditem {
        width: 100%;
        margin-top: 24px;
        background: #fbfbfb;
        padding: 28px;
        cursor: pointer;
        &:hover {
          .cont_w {
            color: #0465ea;
          }
        }
        .cont_w,
        .cont_d {
          img {
            width: 26px;
            height: 26px;
            margin-right: 16px;
          }
        }
        .cont_w {
          font-size: 16px;
          color: #333;
        }
        .cont_d {
          margin-top: 18px;
          font-size: 14px;
          color: #999;
        }
        .cont_bom {
          margin-top: 18px;
          font-size: 12px;
          color: #999;
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-left: 10px;
          }
          span {
            color: #0465ea;
            margin-left: 10px;
          }
        }
      }
    }
    ::v-deep .is-active .el-carousel__button {
      background: #0465ea;
    }
    ::v-deep .el-carousel__button {
      height: 6px;
      border-radius: 3px;
      background-color: #E4E7E8;
      opacity: 1;
    }
  }
}
</style>